module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_1080.849e9188.jpg";